import { addError } from 'app/errors';
import startOperation from './start-operation';
import finishOperation from './finish-operation';
import failOperation from './fail-operation';

export default function trackOperation(operation, id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(startOperation(id));

      operation
        .then(result => {
          dispatch(finishOperation(id));
          resolve(result);
        })
        .catch(error => {
          dispatch(failOperation(id, error));
          dispatch(addError(id, error));
          reject(error);
        });
    });
}
